import { render, staticRenderFns } from "./TheBlogModal.vue?vue&type=template&id=3c4a9609"
import script from "./TheBlogModal.vue?vue&type=script&lang=js"
export * from "./TheBlogModal.vue?vue&type=script&lang=js"
import style0 from "./TheBlogModal.vue?vue&type=style&index=0&id=3c4a9609&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports